export const translations = {
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      courses: 'Courses',
      portfolio: 'Portfolio',
      about: 'About',
      bookNow: 'Book Now',
      bookAppointment: 'Book Appointment',
    },
    footer: {
      description: 'Premium acrylic, gel, and custom nail designs by an experienced Montreal nail artist. Elevating your everyday elegance.',
      explore: 'Explore',
      nailCourses: 'Nail Courses',
      connect: 'Connect',
      rights: 'All rights reserved.',
    },
    home: {
      heroTitleLine1: 'Luxury Nail Art &',
      heroTitleAccent: 'Courses',
      heroTitleLine2: 'in Montreal',
      heroDescription: 'Premium acrylic, gel, and custom nail designs by an experienced Montreal nail artist. Book your appointment or start your nail career with professional training.',
      exploreCourses: 'Explore Courses',
      yearsExperience: 'Years Experience',
      happyClients: 'Happy Clients',
      ratedSalon: 'Rated Salon Montreal',
      signatureServices: 'Signature Services',
      signatureServicesDescription: 'Elevate your look with our premium nail and beauty services tailored to your unique style.',
      viewAll: 'View All',
      bookService: 'Book Now',
      ctaTitle: 'Master the Art of Nails in Montreal',
      ctaDescription: 'Whether you\'re starting from scratch or looking to refine your advanced techniques, our comprehensive nail courses provide the hands-on training you need to succeed in the beauty industry.',
      ctaBullets: [
        'Beginner Acrylic Fundamentals',
        'Advanced Nail Art Techniques',
        '1-on-1 Private Mentorship'
      ],
      exploreNailCourses: 'Explore Nail Courses',
      heroAlt: 'Luxury Nail Art Montreal',
      coursesAlt: 'Montreal Nail Courses',
    },
    services: {
      title: 'Nail & Beauty Services',
      titleSuffix: 'in Montreal',
      description: 'Experience luxury nail care and skin treatments designed to enhance your natural beauty. Using only premium products for long-lasting, flawless results.',
      bookThisService: 'Book This Service',
    },
    courses: {
      title: 'Professional Nail Courses',
      titleSuffix: 'in Montreal',
      description: 'Turn your passion into a profitable career. Our comprehensive nail training programs are designed for all skill levels, providing hands-on experience and industry secrets.',
      viewCourseDetails: 'View Course Details',
    },
    courseDetail: {
      whatYouWillLearn: 'What You\'ll Learn',
      enrollNow: 'Enroll Now',
    },
    portfolio: {
      title: 'Our Work',
      follow: 'Follow @nailedbyliana',
      imageAlt: 'Professional Nail Art',
    },
    about: {
      eyebrow: 'The Artist',
      title: 'Meet Liana',
      paragraph1: 'With 8+ years of experience, Liana has established herself as one of Montreal\'s most sought-after nail artists. Specializing in intricate nail art and pristine acrylics, she views every set as a miniature canvas.',
      paragraph2: 'Her dedication to perfection extends to education, where she shares her secrets with aspiring nail technicians through hands-on courses.',
      imageAlt: 'Liana',
    },
    contact: {
      title: 'Book Your Experience',
      description: 'Ready to elevate your nails or start your career? Fill out the inquiry form below, and we will get back to you within 24-48 hours.',
      requestReceived: 'Request Received',
      requestReceivedDescription: 'We will be in touch shortly.',
      fullName: 'Full Name *',
      email: 'Email *',
      instagram: 'Instagram Handle',
      submit: 'Submit Request',
    },
  },
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      courses: 'Formations',
      portfolio: 'Portfolio',
      about: 'À propos',
      bookNow: 'Réserver',
      bookAppointment: 'Prendre rendez-vous',
    },
    footer: {
      description: 'Ongles acryliques, gels et créations personnalisées haut de gamme réalisés par une prothésiste ongulaire expérimentée à Montréal. Pour sublimer votre élégance au quotidien.',
      explore: 'Explorer',
      nailCourses: 'Formations ongulaires',
      connect: 'Coordonnées',
      rights: 'Tous droits réservés.',
    },
    home: {
      heroTitleLine1: 'Art ongulaire de luxe &',
      heroTitleAccent: 'Formations',
      heroTitleLine2: 'à Montréal',
      heroDescription: 'Ongles acryliques, gels et créations personnalisées haut de gamme réalisés par une prothésiste ongulaire expérimentée à Montréal. Prenez rendez-vous ou lancez votre carrière grâce à une formation professionnelle.',
      exploreCourses: 'Découvrir les formations',
      yearsExperience: 'Ans d\'expérience',
      happyClients: 'Clientes satisfaites',
      ratedSalon: 'Salon très bien noté à Montréal',
      signatureServices: 'Services signature',
      signatureServicesDescription: 'Sublimez votre style grâce à nos services premium d\'onglerie et de beauté, adaptés à votre univers.',
      viewAll: 'Voir tout',
      bookService: 'Réserver',
      ctaTitle: 'Maîtrisez l\'art des ongles à Montréal',
      ctaDescription: 'Que vous débutiez ou souhaitiez perfectionner vos techniques avancées, nos formations complètes vous offrent la pratique nécessaire pour réussir dans l\'industrie de la beauté.',
      ctaBullets: [
        'Bases de l\'acrylique pour débutantes',
        'Techniques avancées de nail art',
        'Mentorat privé individuel'
      ],
      exploreNailCourses: 'Découvrir les formations',
      heroAlt: 'Art ongulaire de luxe à Montréal',
      coursesAlt: 'Formations ongulaires à Montréal',
    },
    services: {
      title: 'Services beauté & ongles',
      titleSuffix: 'à Montréal',
      description: 'Profitez de soins ongulaires luxueux et de traitements de la peau conçus pour mettre en valeur votre beauté naturelle. Nous utilisons uniquement des produits haut de gamme pour des résultats durables et impeccables.',
      bookThisService: 'Réserver ce service',
    },
    courses: {
      title: 'Formations professionnelles',
      titleSuffix: 'à Montréal',
      description: 'Transformez votre passion en carrière rentable. Nos programmes complets de formation ongulaire s\'adressent à tous les niveaux et offrent une expérience pratique ainsi que des secrets du métier.',
      viewCourseDetails: 'Voir les détails',
    },
    courseDetail: {
      whatYouWillLearn: 'Ce que vous apprendrez',
      enrollNow: 'S\'inscrire',
    },
    portfolio: {
      title: 'Nos réalisations',
      follow: 'Suivre @nailedbyliana',
      imageAlt: 'Création ongulaire professionnelle',
    },
    about: {
      eyebrow: 'L\'artiste',
      title: 'Rencontrez Liana',
      paragraph1: 'Avec plus de 8 ans d\'expérience, Liana s\'est imposée comme l\'une des prothésistes ongulaires les plus recherchées de Montréal. Spécialisée dans le nail art minutieux et les poses acryliques impeccables, elle considère chaque pose comme une toile miniature.',
      paragraph2: 'Son exigence de perfection s\'étend aussi à l\'enseignement, où elle partage ses secrets avec les futures techniciennes ongulaires à travers des formations pratiques.',
      imageAlt: 'Liana',
    },
    contact: {
      title: 'Réservez votre expérience',
      description: 'Prête à sublimer vos ongles ou à lancer votre carrière? Remplissez le formulaire ci-dessous et nous vous répondrons sous 24 à 48 heures.',
      requestReceived: 'Demande reçue',
      requestReceivedDescription: 'Nous vous contacterons très bientôt.',
      fullName: 'Nom complet *',
      email: 'Courriel *',
      instagram: 'Nom Instagram',
      submit: 'Envoyer la demande',
    },
  },
};
